<template>
  <Row>

    <div class="demo-upload-list" v-for="(item,index) in uploadList" :key="index"
         :style="{width:imageStyle?'80px':'60px',height:imageStyle?'105px':'60px'}">
      <template v-if="item.status === 'finished'">
          <img :src="item.url">
          <div class="demo-upload-list-cover">
            <Icon type="ios-eye-outline" @click.native="handleView(item,index)"></Icon>
            <Icon v-if="!showdisabled" type="ios-trash-outline" @click.native="handleRemove(item)"></Icon>
          </div>
      </template>
      <template v-else>
        <Progress v-if="item.showProgress" :percent="item.percentage" hide-info></Progress>
      </template>
    </div>

    <Upload v-if="multiple||(!multiple&&!uploadList.length)" ref="upload" :show-upload-list="false"
            :default-file-list="defaultList" :on-success="handleSuccess"
            :format="format" :accept="accept" :max-size="0" :on-format-error="handleFormatError"
            :on-exceeded-size="handleMaxSize" :before-upload="handleBeforeUpload"
            :multiple="multiple" type="drag" :action="isThumb?actionthumb:action" :headers="headers"
            :data="filedata"
            :style="{width:imageStyle?'80px':'58px',height:imageStyle?'105px':'58px'}"
            style="display: inline-block;">
      <div
        :style="{width:imageStyle?'80px':'58px',height:imageStyle?'105px':'58px',lineHeight:imageStyle?'105px':'58px'}">
        <Icon type="ios-camera" size="20"></Icon>
      </div>
    </Upload>

    <Modal title="View Image" v-model="visible" :styles="{top: '20px',height:'calc(100% - 40px)'}">
      <img :src="imgName" v-if="visible" style="width: 100%">
    </Modal>
  </Row>
</template>
<script>
import { api as viewerApi } from "v-viewer";
export default {
  props: {
    isImgSort: {
      type: Boolean,
      default: false,//多图上传是否排序
    },
    imgsrc: [String, Array],
    multiple: {
      type: Boolean,
      default: false
    },
    delurl: {
      type: [Boolean, String, Number],
      default: false
    },
    //model:'',//模块 book_afterRead读后感  book书籍图片
    //filetype:'',//images（图片）、video（视频）、audio（音频）、file（文件）
    filedata: {
      type: [Boolean, Object],
      default: false
    },
    // 是否生成缩略图
    isThumb: {
      type: [Boolean],
      default: false
    },
    // 预览还是编辑 true预览 false编辑
    showdisabled: {
      type: [Boolean],
      default: false
    },
    //判断删除是书籍多图形式，还是资源删除形式，默认书籍形式'bookdel',资源形式'resourcesdel'
    delType: {
      type: [Boolean, String],
      default: 'bookdel'
    },
    //单图上传后的图片样式
    imageStyle: {
      type: [Boolean],
      default: false
    }

  },

  mounted() {
    this.ImgUpStorList = []
    if (typeof this.filedata == 'object') {
      this.$set(this.filedata, 'apiterminal', 'Aqt_20230517ApiWeb')
    }

    let bool = Array.isArray(this.imgsrc)
    if (bool) {
      this.defaultList = this.imgsrc
      setTimeout(() => {
        this.uploadList = this.$refs.upload ? this.$refs.upload.fileList : ''
      }, 1500)
    } else {
      if (this.imgsrc) {
        this.defaultList.push({
          name: '已上传图片',
          url: this.imgsrc,
          used: 1,//表示读的是旧的图片
          delurl: false,//表示单图删除时不走接口，只要置空就可以了，因为单挑查询没有返回封面图的id
        })
        setTimeout(() => {
          this.uploadList = this.$refs.upload ? this.$refs.upload.fileList : ''
        }, 1500)
      }
    }

  },
  data() {
    return {

      imgName: '',
      visible: false,
      uploadList: [],
      defaultList: [],
      action: `${this.$api.host}api/user/v1/uploadoss`,
      actionthumb: `${this.$api.host}api/user/v1/uploadossthumb`,
      headers: {
        Authorization: 'Bearer ' + (localStorage.token || '')
      },

      format: (this.isThumb ? ['jpg', 'jpeg'] : ['jpg', 'jpeg', 'png', 'gif']),
      accept: (this.isThumb ? '.jpg, .jpeg' : '.jpg, .jpeg, .png, .gif'),

      ImgUpStorList: []
    }
  },
  methods: {
    handleView(item,index) {
      let that = this
      // this.imgName = name;
      // this.visible = true;

      // let urlList = this.uploadList.map(it=>{
      //   return it.url
      // })
      // viewerApi({
      //   images: urlList,
      //   title: false
      // })

      viewerApi({
        options: {
          toolbar: true,
          url: 'url',
          initialViewIndex: index
        },
        images: that.uploadList
      })
    },
    handleRemove(file) {
      if (this.delurl) {
        if (this.delurl === 1) {
          // 表示是修改页面中的删除图片
          if (this.multiple) {
            // 表示删除的是多图
            if (file.delurl) {
              // 删除的久的图片

              if (this.delType == 'bookdel') {
                this.delSubmit(file.delurl, file.id, file.type)
              } else if (this.delType == 'resourcesdel') {
                this.delResoureSubmit(file)
              }

            } else {
              let index = null
              if (file.response) {
                index = this.uploadList.findIndex(el => el.response && el.response.data.id === file.response.data.id)
              } else {
                index = this.uploadList.findIndex(el => el.url === file.url)
              }
              if (index >= 0) {
                this.uploadList.splice(index, 1)
                this.$emit('remove-files', this.uploadList)
              }
            }
          } else {
            // 表示删除的是单图，不需要走接口
            this.uploadList = []
            this.$emit('remove-files', this.uploadList)
          }
        } else {
          if (this.delType == 'bookdel') {
            this.delSubmit(false)
          } else if (this.delType == 'resourcesdel') {
            this.delResoureSubmit(false)
          }
        }
      } else {
        if (this.multiple) {
          let index = this.uploadList.findIndex(el => el.response.data.id === file.response.data.id)
          if (index >= 0) {
            this.uploadList.splice(index, 1)
            this.$emit('remove-files', this.uploadList)
          }
        } else {
          this.uploadList = []
          this.$emit('remove-files', this.uploadList)
        }
      }
    },

    delSubmit(file, id = false, type = false) {
      let that = this
      that.$Modal.confirm({
        title: that.$t('m.del_info'),
        closable: true,
        loading: true,
        closable: false,
        content: that.$t('m.sure_del'),
        onOk: () => {
          that.delImage(file, id, type)
        }
      })
    },

    async delImage(file, id, type) {
      let that = this
      let cond = {
        id: id,
        type: type
      }
      let url = file ? file : that.delurl
      that.$Modal.remove()
      try {
        const res = await this.$httpsencrypt.post(url, cond)
        if (res.code === 200) {
          if (this.multiple) {
            let index = that.uploadList.findIndex(el => el.id === id)
            if (index >= 0) {
              that.uploadList.splice(index, 1)
              that.$emit('remove-files', that.uploadList)
            }
          } else {
            this.uploadList = []
            that.$emit('remove-files')
          }
        } else {
          that.$Message.warning(this.$t('m.net_error'))
        }
      } catch (error) {
        // that.$Message.warning(this.$t('m.net_error'))
      }
    },

    delResoureSubmit(file) {
      let that = this
      that.$Modal.confirm({
        title: that.$t('m.del_info'),
        closable: true,
        loading: true,
        closable: false,
        content: that.$t('m.sure_del'),
        onOk: () => {
          that.delResoureImage(file)
        }
      })
    },

    async delResoureImage(data) {
      let that = this
      let cond = {
        table_name: data.table_name,
        table_key: data.table_key,
        table_keyid: data.table_keyid,
        model: data.model,
        quality: 1,//文件种类 1原图(普清) 2压缩
        type: data.type,// 1文件 2图片3视频 4音频
        resources_id: data.id,//单独删除传，根据书籍删除时不传
        deltype: false,//用于内容信息列表中的删除true 单个删除资源fals
      }

      let url = data.delurl ? data.delurl : that.delurl
      that.$Modal.remove()
      try {
        const res = await this.$httpsencrypt.post(url, cond)
        if (res.code === 200) {
          if (this.multiple) {
            let index = that.uploadList.findIndex(el => el.id === data.id)
            if (index >= 0) {
              that.uploadList.splice(index, 1)
              that.$emit('remove-files', that.uploadList)
            }
          } else {
            this.uploadList = []
            that.$emit('remove-files')
          }
          that.$Message.success('文件已删除')
        } else {
          that.$Message.warning(this.$t('m.net_error'))
        }
      } catch (error) {
      }
    },


    handleSuccess(res, file) {
      file.url = res.data.file_url
      if (!this.multiple) this.uploadList.push(file)
      this.$emit('on-files', res.data)
    },
    handleFormatError(file) {
      this.$Notice.warning({
        title: '格式不正确，上传失败！',
        desc: '图片 ' + file.name + ' 的格式必须是 ' + (this.isThumb ? 'jpg' : 'jpg, jpeg, png')

      });
    },
    handleMaxSize(file) {
      this.$Notice.warning({
        title: '上传图片太大',
        desc: '图片  ' + file.name + ' 不能超出 2M.'
      });
    },
    handleBeforeUpload(file) {
      let that = this
      if (that.showdisabled){
          this.$Notice.warning({
            title: '禁止上传'
          });
        return false
      }
      if (that.isImgSort) {
        let re = {
          data: ''
        }
        let cont = {
          status: '',
          name: file.name,
          size: file.size,
          response: re
        }
        that.uploadList.push(cont)
        that.ImgUpStorList.push(file)
        if (that.ImgUpStorList.length && that.ImgUpStorList[0].name == file.name) {
          that.pushUrlImg(that.ImgUpStorList[0], 0)
        }
        return false
      } else {
        //正常的
        const check = this.multiple ? true : this.uploadList.length < 1;
        if (!check) {
          this.$Notice.warning({
            title: '最多可上传一张'
          });
        }
        return check;
      }


    },
    pushUrlImg(file, length) {
      let that = this
      let isOk = false
      const formData = new FormData();
      formData.append('file', file);
      for (let key in that.filedata) {
        formData.append(key, that.filedata[key]);
      }

      let url = that.isThumb ? that.actionthumb : that.action

      // 发送图片文件到后端上传接口
      fetch(url, {
        method: 'POST',
        body: formData,
        headers: that.headers
      })
        .then(response => response.json())
        .then(res => {

          file.url = res.data.file_url
          that.uploadList.forEach(i => {
            if (i.name == res.data.name && i.size == res.data.size) {
              i.status = 'finished'
              i.url = res.data.file_url
              i.id = res.data.id
              i.response.data = res.data
            }
          })
          that.$emit('on-files', res.data)


          if (length + 1 < that.ImgUpStorList.length) {
            length++
            isOk = true
          } else {
            isOk = false
            that.ImgUpStorList = []
          }
          if (isOk) {
            that.pushUrlImg(that.ImgUpStorList[length], length)
          }


        })
        .catch(error => {
        });


    }
  }
}
</script>
<style>
.demo-upload-list {
  display: inline-block;
  width: 60px;
  height: 60px;
  text-align: center;
  line-height: 60px;
  border: 1px solid transparent;
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
  position: relative;
  box-shadow: 0 1px 1px rgba(0, 0, 0, .2);
  margin-right: 4px;
}

.demo-upload-list img {
  width: 100%;
  height: 100%;
  display: block;
}

.demo-upload-list-cover {
  display: none;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, .6);
}

.demo-upload-list:hover .demo-upload-list-cover {
  display: block;
}

.demo-upload-list-cover i {
  color: #fff;
  font-size: 20px;
  cursor: pointer;
  margin: 0 2px;
}

.imgBorder {
  width: 80px;
  height: 105px;
  border: 1px solid #dcdee2;
  display: flex;
  justify-content: center;
  align-items: center;
}

.imgYlborder {
  width: 58px;
  display: contents;
}
</style>
